export default __webpack_public_path__ + "static/media/selectphoto.24a8cfd2.mp4";